import makeStyles from '@mui/styles/makeStyles';

import { formGridClasses } from '../../../../../styles/formGridStyles';
import { Theme } from '../../../../../types';

export const MIN_ACTION_WIDTH = 124;

const serviceSectionStyles = makeStyles((theme: Theme) => ({
    ...formGridClasses(theme),
    widthFillAvailable: {
        width: '-webkit-fill-available'
    },
    padding0: {
        padding: 0
    },
    margin0: {
        margin: 0
    },
    orderFirstColPadding: {
        '& table': {
            width: '100%',
            tableLayout: 'fixed'
        },
        '& th': {
            resize: 'horizontal',
            overflow: 'hidden'
        },
        '& .MuiTableRow-root': {
            '& .MuiTableCell-root:first-of-type': {
                padding: theme.spacing(0, 0.5, 0, 1)
            }
        }
    },
    tableWrapperDetailPanelStyle: {
        margin: theme.spacing(0, 1, 2, 0),
        '& .MuiTableRow-root': {
            '& .MuiTableCell-root:last-child': {
                minWidth: `${MIN_ACTION_WIDTH}px !important`,
                padding: 0
            }
        }
    },
    minHeight40vh: {
        minHeight: '40vh'
    },
    maxWidth600px: {
        maxWidth: '600px'
    },
    maxWidth800px: {
        maxWidth: '800px'
    },
    maxWidth1100px: {
        maxWidth: '1100px'
    },
    minWidth280px: {
        minWidth: '280px'
    },
    minWidth160px: {
        minWidth: '160px'
    },
    minWidth150px: {
        minWidth: '150px'
    },
    minWidth90px: {
        minWidth: '90px'
    },
    minWidth60px: {
        minWidth: '60px'
    },

    positionRelative: {
        position: 'relative'
    },
    wrapAbsoluteButtons: {
        position: 'absolute',
        zIndex: 20,
        right: '7px',
        top: '2px'
    },
    marginBottom2: {
        marginBottom: theme.spacing(2)
    },

    colorAndBorderError: {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
        '&:hover': {
            borderColor: theme.palette.error.main
        }
    },
    voucherLink: {
        // CSS var so it re-resolves on theme change (grid/table cells don't
        // re-render on theme flip).
        color: 'var(--vt-voucher, #802922)',
        '&:hover': {
            color: theme.palette.primary.main,
            textDecoration: 'underline'
        }
    },
    refundLink: {
        color: 'red',
        '&:hover': {
            color: theme.palette.primary.main,
            textDecoration: 'underline'
        }
    },
    cancelVoucherLink: {
        color: 'gray',
        textDecoration: 'line-through',
        '&:hover': {
            color: theme.palette.primary.main
        }
    },
    marginLeft1: {
        marginLeft: theme.spacing(1)
    },
    padding5px: {
        padding: '5px'
    },
    padding3px: {
        padding: '3px'
    },
    cursorAuto: {
        cursor: 'auto'
    },
    tooltipBorderStyle: {
        fontWeight: 500,
        whiteSpace: 'pre-line',
        border: '2px solid',
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.grey[200],
        position: 'relative'
    },
    fontWeightBold: {
        fontWeight: 'bold'
    },
    toolbarIcon: {
        margin: '-4px',
        display: 'flex'
    },
    widthAuto: {
        width: 'auto'
    },
    padding2: {
        padding: theme.spacing(2)
    },
    padding3: {
        padding: theme.spacing(3)
    },
    paddingBottom2: {
        paddingBottom: theme.spacing(2)
    },
    paddingRight1: {
        paddingRight: theme.spacing(1)
    },
    marginTop2px: {
        marginTop: '2px'
    },
    flexAlignCenter: {
        display: 'flex',
        alignItems: 'center'
    },
    paddingLeft1: {
        paddingLeft: theme.spacing(1)
    },
    fontWeight500: {
        fontWeight: 500
    },
    marginTop2: {
        marginTop: theme.spacing(2)
    },
    marginTop0: {
        marginTop: 0
    },
    wrapTooltipIcon: {
        paddingBottom: '3px',
        flexShrink: 100,
        display: 'flex',
        alignItems: 'flex-end'
    },
    minHeight400px: {
        minHeight: '400px'
    },
    accentColor: {
        // @ts-ignore
        color: theme.palette.accent.main
    },
    uppercase: {
        textTransform: 'uppercase'
    },
    addServiceBtn: {
        '&.MuiButton-root': {
            // Dark mode: use a control surface from the palette instead of a
            // bright white pill on the dark section header.
            backgroundColor:
                theme.palette.mode === 'dark' ? 'var(--input-bg)' : theme.palette.common.white,
            border:
                theme.palette.mode === 'dark'
                    ? '1px solid var(--input-border)'
                    : `1px solid ${theme.palette.grey[300]}`,
            borderRadius: 8,
            padding: theme.spacing(0.5, 1.5),
            color: theme.palette.text.secondary,
            textTransform: 'none' as const,
            fontSize: '0.8rem',
            fontWeight: 500,
            minHeight: 32,
            boxShadow: 'none',
            transition: 'all 0.15s ease',
            '&:hover': {
                backgroundColor:
                    theme.palette.mode === 'dark' ? 'var(--input-border)' : theme.palette.grey[50],
                borderColor:
                    theme.palette.mode === 'dark'
                        ? 'var(--input-border-hover)'
                        : theme.palette.primary.light,
                color: theme.palette.primary.main,
                boxShadow: 'none'
            }
        },
        '& .MuiTypography-root': {
            fontSize: '0.8rem',
            fontWeight: 500,
            lineHeight: 1.4
        },
        '& .MuiSvgIcon-root': {
            fontSize: '1rem'
        }
    },
    cancelledRow: {
        backgroundColor:
            theme.palette.mode === 'dark'
                ? 'var(--ag-odd-row-background-color, #eee) !important'
                : '#eee !important',
        textDecoration: 'line-through'
    }
}));

export default serviceSectionStyles;
